module.exports = __webpack_public_path__ + "img/Galactapedia_Aopoa.19cbe20b.png";